import { render } from "./LiveDeckEmbed.vue?vue&type=template&id=63a48658&scoped=true"
import script from "./LiveDeckEmbed.vue?vue&type=script&lang=js"
export * from "./LiveDeckEmbed.vue?vue&type=script&lang=js"

import "./LiveDeckEmbed.vue?vue&type=style&index=0&id=63a48658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a48658"]])

export default __exports__